export default "__VITE_ASSET__DOVkoGlE__"